import { getUrlParameter } from '../../../../global/data/url.js'

export default function initStickyHeader() {
  // for taking screenshots for compliance
  if (getUrlParameter('screenshot') === 'true') {
    document.querySelector('.Footer-jumpLink').style.display = 'none'
    return
  }

  window.addEventListener('scroll', fixHeaderOnScroll, false)
  window.addEventListener('jumpScroll', fixHeaderOnScroll, false)
  window.addEventListener('fundViewerActive', fixHeaderOnScroll, false)
}

function fixHeaderOnScroll() {
  const scrollPosition = window.pageYOffset
  const fundHeaderContainer = document.getElementById('fund-header')
  const fundHeaderGrid = document.getElementById('js-fund-header-grid')
  const fundHeaderTitleWrapper = document.getElementById(
    'js-fundHeader-titleWrapper'
  )
  const fundHeaderTextLink = document.getElementById('js-fundHeader-textLink')
  const navOffSet = document.getElementsByClassName('Navigation')[0].offsetTop
  const brandMessageOffset = document.getElementById('brand-message')
    ? document.getElementById('brand-message').offsetTop
    : 0

  const fundViewerBottomScrollLimit = 0
  const bottomScrollLimit = document.getElementById('new-disclosures')
    ? document.getElementById('new-disclosures').offsetTop
    : 300
  const fundViewerOpen = fundViewerBottomScrollLimit > 0
  let jumpScrollInitialLimit = 195 // this is the height of the truncated header (includes subnav)
  let topScrollLimit =
    fundHeaderContainer.offsetTop + navOffSet + brandMessageOffset

  const fundHeaderMessageElement = document.getElementById(
    'fund-header-message'
  )

  if (fundViewerOpen) {
    jumpScrollInitialLimit =
      fundViewerBottomScrollLimit + fundHeaderContainer.offsetHeight
    topScrollLimit =
      fundViewerBottomScrollLimit + fundHeaderContainer.offsetHeight
  }

  if (
    (scrollPosition > jumpScrollInitialLimit ||
      scrollPosition >= topScrollLimit) &&
    scrollPosition <= bottomScrollLimit &&
    !matchMedia('(max-width: 1024px)').matches
  ) {
    const event = new Event('stickyHeaderActive')

    window.dispatchEvent(event)

    if (fundViewerOpen) {
      const mfEvent = new Event('hideMfViewer')

      window.dispatchEvent(mfEvent)
    }

    fundHeaderContainer.classList.remove('u-hidden')
    fundHeaderContainer.classList.add('header-sticky')
    fundHeaderGrid.classList.remove('u-paddingVert4gu')
    fundHeaderGrid.classList.add('u-paddingTop2gu')
    fundHeaderTitleWrapper.classList.remove('u-marginBottom4gu')
    fundHeaderTitleWrapper.classList.add('u-marginBottom1gu')

    if (fundHeaderTextLink) {
      fundHeaderTextLink.classList.remove('u-marginBottom4gu')
      fundHeaderTextLink.classList.add('u-marginBottom1gu')
    }

    if (fundHeaderMessageElement) {
      fundHeaderMessageElement.style.marginTop = '160px'
    }
  } else {
    const event = new Event('stickyHeaderInactive')

    window.dispatchEvent(event)

    if (scrollPosition < topScrollLimit) {
      fundHeaderContainer.classList.remove('header-sticky')
      fundHeaderGrid.classList.remove('u-paddingTop2gu')
      fundHeaderGrid.classList.add('u-paddingVert4gu')
      fundHeaderTitleWrapper.classList.add('u-marginBottom4gu')
      fundHeaderTitleWrapper.classList.remove('u-marginBottom1gu')

      if (fundHeaderTextLink) {
        fundHeaderTextLink.classList.add('u-marginBottom4gu')
      }

      if (fundHeaderMessageElement) {
        fundHeaderMessageElement.style.marginTop = '0px'
      }
    } else if (scrollPosition > bottomScrollLimit) {
      fundHeaderContainer.classList.add('u-hidden')
    }
  }
}
